import { IBook } from './types';
import { getBookTextInputData } from './inputs/text/utils';
import { getBookRadioInputData, getBookRadioInputOptionData } from './inputs/radio/utils';
import { getBookPriceData } from './prices/utils';
import {
  BOOK_ALIAS_STARRY_DREAM,
  INPUT_NAME_KIDS_NAME,
  INPUT_NAME_KIDS_BIRTHDAY,
  INPUT_VALUE_GENDER_BOY,
  INPUT_VALUE_GENDER_GIRL,
  INPUT_NAME_GENDER,
  BOOK_PRICE_STARRY_DREAM,
  BOOK_PRICE_STARRY_DREAM_HARD_COVER,
  INPUT_NAME_CHARACTER,
  INPUT_NAME_LANGUAGE,
  INPUT_VALUE_JAPANESE,
  INPUT_VALUE_ENGLISH,
} from '@shared/book/constants';
import { EBookBannerTextColor } from './banner/types';
import { EBookDescriptionTextItemType } from './desicription/types';
import { getBookNameValidatorList, getBookNameEnValidatorList } from 'src/app/validators';
import { GET_BOOK_NAME_ERROR, GET_BOOK_NAME_ERROR_EN } from 'src/app/validators.constants';
import { getBookDateInputData } from './inputs/date/utils';
import { GENDER_TO_CHARACTER_SD_MAP } from '@shared/book/maps';
import { getBookRadioImageInputData, getBookRadioImageInputOptionData } from './inputs/radioImage/utils';
import { bookInputShowWhen, bookInputValidatorWhen } from './inputs/utils';
import { TGender, TLanguage } from '@shared/book/interfaces';
import { languageArr } from '@shared/book/data';
import { getBookSelectInputOptionData, getBookSelectInputData } from './inputs/select/utils';

/**
 * * validatorWhen and showWhen are set inside IBook['inputs']
 * * by mutation funtions `bookInputValidatorWhen` and `bookInputShowWhenCheck`
 * * to make it possible to assign inputs between each other
 */

const StarryDreamInputsKidsNameValidator = getBookNameValidatorList(6);
const StarryDreamInputsKidsNameValidatorEn = getBookNameEnValidatorList(12);

export const StarryDreamInputsKidsName = getBookTextInputData({
  label: 'Kid’s name',
  get placeholder() {
    return this.validator === StarryDreamInputsKidsNameValidatorEn
      ? 'Up to 12 characters EN' as const
      : 'Up to 6 characters' as const;
  },
  // value: '',
  name: INPUT_NAME_KIDS_NAME,
  // will be added in inputs array
  // validator: getBookNameValidatorList(6),
  get error() {
    return this.validator === StarryDreamInputsKidsNameValidatorEn
      ? GET_BOOK_NAME_ERROR_EN(12)
      : GET_BOOK_NAME_ERROR(6);
  },
} as const);

export const StarryDreamInputsKidsBirthday = getBookDateInputData({
  label: 'Kid’s birthday',
  placeholder: 'yyyy/mm/dd',
  // value: new Date(),
  max: new Date(),
  name: INPUT_NAME_KIDS_BIRTHDAY,
});

export const StarryDreamInputsLanguage = getBookSelectInputData({
  label: 'Language',
  placeholder: '',
  options: languageArr.map(
    (lang) => getBookSelectInputOptionData({ label: lang, value: lang }),
  ),
  value: INPUT_VALUE_JAPANESE,
  name: INPUT_NAME_LANGUAGE,
} as const);

export const StarryDreamInputsGender = getBookRadioInputData({
  label: 'Gender',
  options: [
    getBookRadioInputOptionData({
      label: 'Boy',
      // imgSrc: '/assets/images/radio-boy.png',
      value: INPUT_VALUE_GENDER_BOY
    }),
    getBookRadioInputOptionData({
      label: 'Girl',
      // imgSrc: '/assets/images/radio-girl.png',
      value: INPUT_VALUE_GENDER_GIRL
    }),
  ],
  value: INPUT_VALUE_GENDER_BOY,
  name: INPUT_NAME_GENDER,
});

export const StarryDreamInputsCharacterBoy = getBookRadioImageInputData({
  label: 'Choose character that looks a like!',
  options: GENDER_TO_CHARACTER_SD_MAP[INPUT_VALUE_GENDER_BOY].map(
    (value, index) => getBookRadioImageInputOptionData({
      imgSrc: `/assets/images/sd-characters/boy/${index + 1}.png`,
      value,
    })
  ),
  // value: '',
  name: INPUT_NAME_CHARACTER,
} as const);

export const StarryDreamInputsCharacterGirl = getBookRadioImageInputData({
  label: 'Choose character that looks a like!',
  options: GENDER_TO_CHARACTER_SD_MAP[INPUT_VALUE_GENDER_GIRL].map(
    (value, index) => getBookRadioImageInputOptionData({
      imgSrc: `/assets/images/sd-characters/girl/${index + 1}.png`,
      value,
    })
  ),
  // value: '',
  name: INPUT_NAME_CHARACTER,
} as const);

const StaryDream: IBook = {
  caption: 'Starry Dream',
  summary: ['星座に導かれて、不思議な星の旅へ。主人公の成長を願う星の物語。'],
  alias: BOOK_ALIAS_STARRY_DREAM,
  prices: [
    ['soft', getBookPriceData(BOOK_PRICE_STARRY_DREAM)],
    ['hard', getBookPriceData(BOOK_PRICE_STARRY_DREAM_HARD_COVER)],
  ],
  photos: [
    '/assets/images/book1-carousel01.jpg',
    '/assets/images/book1-carousel02.jpg',
    '/assets/images/book1-carousel03.jpg',
  ],
  menuPhoto: '/assets/images/cart-product-photo.png',
  previewPhoto: '/assets/images/book1-books.png',
  properties: {
    purpose: ['Adventure'],
    age: {
      start: 3,
      end: 8,
    },
  },
  notice: {
    caption: 'Our best sold book',
    description: 'starry.dream.description',
    points: [
      {
        imgSrc: '/assets/images/starry-dream-notice-point-1.png',
        caption: 'starry.dream.notice.point.1',
      },
      {
        imgSrc: '/assets/images/starry-dream-notice-point-2.png',
        caption: 'starry.dream.notice.point.2',
      },
    ],
  },
  points: [
    {
      caption: 'どんなカスタマイズができるの？',
      description: 'お誕生日をもとに星座のお話がつくられ、イラストの一部にはその子が生まれた日の星空が。メッセージを編集したり写真を追加したりもできます。',
    },
    {
      caption: '絵本のストーリーは？',
      description: 'ある夜、主人公に届いたのはキラキラひかる招待状。招待状を元に、「生まれた時から一緒だった」と言う星座のキャラクターに導かれて向かったのは、不思議な不思議な３つの星。',
    },
    {
      caption: 'ページ数や絵本の大きさは？',
      description: '全30ページ、大きさは幅29.7cm 高さ21cmのA4横。',
    },
  ],
  inputs: [
    bookInputValidatorWhen(
      StarryDreamInputsKidsName,
      [
        {
          validator: StarryDreamInputsKidsNameValidatorEn,
          showWhen: [{
            inputToCheck: StarryDreamInputsLanguage,
            condition: (language: TLanguage) => language === INPUT_VALUE_ENGLISH,
          }],
        }, {
          validator: StarryDreamInputsKidsNameValidator,
          showWhen: [{
            inputToCheck: StarryDreamInputsLanguage,
            condition: (language: TLanguage) => language === INPUT_VALUE_JAPANESE,
          }]
        }
      ]
    ),
    StarryDreamInputsKidsBirthday,
    StarryDreamInputsLanguage,
    StarryDreamInputsGender,
    bookInputShowWhen(
      StarryDreamInputsCharacterBoy,
      StarryDreamInputsGender,
      (gender: TGender) => gender === INPUT_VALUE_GENDER_BOY,
    ),
    bookInputShowWhen(
      StarryDreamInputsCharacterGirl,
      StarryDreamInputsGender,
      (gender: TGender) => gender === INPUT_VALUE_GENDER_GIRL,
    ),
  ],
  banner: {
    imgSrc: '/assets/images/book1-banner-desktop.png',
    imgSrcLtMd: '/assets/images/book1-banner-mobile.png',
    text: 'よるのそらを　みあげれば、　またいつでも　あえるよ。',
    textColor: EBookBannerTextColor.light,
  },
  description: [
    {
      imgSrc: '/assets/images/book1-images01.gif',
      text: [
        {
          type: EBookDescriptionTextItemType.caption,
          text: '星座と行く、不思議な星の旅'
        }, {
          type: EBookDescriptionTextItemType.regular,
          text: 'ある日届いた星座からの招待状に導かれ、主人公が向かったのは、見たことも聞いたこともない不思議な星々。'
        }, {
          type: EBookDescriptionTextItemType.regular,
          text: 'そこでは、素敵な出会いが、主人公を待っている。',
        },
      ],
    }, {
      imgSrc: '/assets/images/book1-images02.png',
      text: [
        {
          type: EBookDescriptionTextItemType.caption,
          text: '生まれた日の星空がイラストに'
        }, {
          type: EBookDescriptionTextItemType.regular,
          text: '最初は怖かった夜の星。でも、旅を終えて見上げてみると、なんだか懐かしい星空だった。'
        }, {
          type: EBookDescriptionTextItemType.regular,
          text: 'その星空は、過去の衛星データから再現した、主人公が生まれた日の実際の星空。',
        },
      ],
    },
  ],
  reviews: [
    {
      photoImgSrc: '/assets/images/review4.jpg',
      userPhotoImgSrc: '/assets/images/review4-icon.png',
      userName: 'せなくん',
      text: [
        '息子のクリスマスプレゼントで購入🎄🎁',
        '息子が主人公で物語がはじまるとっても素敵な絵本💐',
        '絵も可愛くて息子も母もニコニコ︎︎︎︎︎😀',
        'パパとままもびっくりしてました。',
        '出産祝いにもいいなって思った🕊',
      ],
    }, 
     {
      photoImgSrc: '/assets/images/review1.png',
      userPhotoImgSrc: '/assets/images/review1user.png',
      userName: 'ゆのちゃん',
      text: [
        '「たのしかったです。',
        'えほんがめっちゃかわいいです。',
        'きにいりました。',
        'パパとままもびっくりしてました。',
        'ゆのちゃんのえほんがあるなんておもいもしませんでした。」',
      ],
    },
    {
      photoImgSrc: '/assets/images/review5.jpg',
      userPhotoImgSrc: '/assets/images/review5-icon.png',
      userName: 'はるまくん',
      text: [
        '届いた絵本をさっそく見せたらこんなにニコニコ😊',
        '読み聞かせたら、大好きなトリケラトプスがいて、大喜びでした。自分の誕生日のお話ってわかったかどうか・・。でもケーキの絵を見てハッピーバースデー歌ってました🎂',
        '素敵な絵本ありがとうございました。',
      ],
    },
    {
      photoImgSrc: '/assets/images/review2.png',
      userPhotoImgSrc: '/assets/images/review2user.png',
      userName: 'てんげんくん',
      text: [
        '自分が主人公になれて本の内容も自由に選べるオリジナル絵本📖♥️♥️かわいいっっ📖💓',
      ],
    },
    {
      photoImgSrc: '/assets/images/review3.png',
      userPhotoImgSrc: '/assets/images/review3user.png',
      userName: 'あづきちゃん',
      text: [
        '昨日、絵本届きました。',
        '娘が手に取った瞬間から大喜びでした。',
        '自分の名前と写真が入った、特別な本ということで、何度も何度も読んでいました。',
        'ありがとうございました☺️💕',
      ],
    },
  ],
};

export default StaryDream;
